import { Route } from 'vue-router';

export function hasQueryParams(route: Route) {
  return !!Object.keys(route.query).length;
}

export function hasUTMQueryParams(route: Route) {
  return Object.keys(route.query)
    .map(key => key.toLowerCase())
    .some(key => key.includes('utm'));
}
